import { DatePipe } from "@angular/common";

export const getFormattedDate = (date, format = "MMM dd, yyyy") => {
    const pipe = new DatePipe('en-US');
    const myFormattedDate = pipe.transform(date, format);
    return myFormattedDate;
}